import { fetchWithTimeout } from "./Timeout";
import { CheckSessionTimeout } from "./CheckSessionTimeout";
export async function FetchOptionsChainTickers(ticker) {

    const Token = sessionStorage.getItem("Token");
    const header = { Authorization: `Bearer ${Token}` };

    var requestOptions = {
        method: "GET",
        headers: header,
        redirect: "follow",
    };
    if (!CheckSessionTimeout(Token)){
        try {
            const response = await fetchWithTimeout(
                process.env.REACT_APP_FETCH_AVAILABLE_OPTION_CHAINS_API+"?session_id=" + Token+"&ticker="+ticker,
                requestOptions
            );
            const message = await response.text();
            if (!response.ok) {
                return { status: response.status, error: message.error || message };
            } else {
                return { status: response.status, result: message };
            }
        } catch (error) {
            return { status: 0, error: error.message };
        }
    } else {
        return { status: 401 };
    }
}
